import {
  isTourStartable,
  parseTourLaunchParams,
  type TourGateContext,
} from '@ardoq/product-tours';
import type { StartTourAtStepPayload } from './actions';

export type TourLaunchUrlParams = {
  tourId: string | undefined;
  step: string | undefined;
};

export type ToTourLaunchArgs = {
  urlParams: TourLaunchUrlParams;
  gate: TourGateContext;
};

export const toTourLaunch = ({
  urlParams: { tourId, step },
  gate,
}: ToTourLaunchArgs): StartTourAtStepPayload | null => {
  const launch = parseTourLaunchParams({ tourId, step });
  if (!launch) return null;

  const { tourId: launchTourId, stepIndex } = launch;
  if (!isTourStartable(launchTourId, gate)) {
    return null;
  }
  return { tourId: launchTourId, stepIndex };
};
